import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';
import getSteelCategoryName from '../../utils/getSteelCategoryName';
import type { ICellRendererParams } from 'ag-grid-community';

const SteelCategoryCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  const steelCategoryCodes: string[] = Array.isArray(params.value) ? params.value : [params.value];
  // console.log(steelCategoryCodes);
  const { currentLang } = useLocales();
  const { steelCategory } = useSelector((state: RootState) => state.options);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    // 分類コードの配列を分類名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
    const mappedCodes: string[] = steelCategoryCodes.map((code) => {
      const steelCategoryName: string = getSteelCategoryName(code, steelCategory, currentLang.value);
      return steelCategoryName;
    });
    setDisplayName(mappedCodes.join(', '));
  }, [steelCategory, currentLang]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="steel-category-name">{displayName}</span>;
};

export default SteelCategoryCellRenderer;
